import React, { Component } from 'react';
import { Table } from 'antd';
import Datatable from '../../Datatable';

class IntialTable extends Component {

  render() {
    let { intial_allocated_service, intial_staff_pagination, intial_selected_row_keys } = this.props;
    return (
      <div>
        <Table
          rowKey={record => record.uuid}
          dataSource={intial_allocated_service}
          pagination={intial_staff_pagination}
          rowSelection={{
            selectedRowKeys: intial_selected_row_keys,
            preserveSelectedRowKeys: true,
            onChange: (intial_selected_row_keys) => {
              this.props.onIntialSelectedRowKeysChange(intial_selected_row_keys)
            },
            getCheckboxProps: (record) => {
              return {
                disabled: record.is_selected || record.status === 'cancelled'
              };
            }
          }}
          onChange={this.props.intialPaginationChange}
          columns={Datatable.ServiceToPerform()}
        />
        {intial_staff_pagination.total > 0 ? this.props.intial_staff_page_size_limit : ""}

      </div>
    );
  }
}

export default IntialTable;